import type {
  QualificationReqPayload,
  QualificationResponse,
} from '../../types/offerings';
import { getApiConfig } from '../../services/api/utils';
import { DeliverySystemApiClient } from '@highereducation/delivery-system';

/**
 * Qualifies a lead against all programs via the Delivery System SDK.
 * Returns lists of qualified and unqualified program IDs.
 */
export const postLeadQualifications = async (
  payload: QualificationReqPayload,
): Promise<QualificationResponse> => {
  const config = getApiConfig();
  const baseUrl = config.deliverySystemApiUrl ?? '';

  // Ensure email and phoneNumber are always present for No-PII data flow
  const normalizedPayload: QualificationReqPayload = {
    ...payload,
    lead: {
      ...payload.lead,
      email: payload.lead?.email ?? '',
      phoneNumber: payload.lead?.phoneNumber ?? '',
    },
  };

  const client = new DeliverySystemApiClient({
    baseUrl,
    defaultHeaders: {
      'Content-Type': 'application/json',
    },
  });

  const response = await client.postLeadQualifications(normalizedPayload);

  if (!response) {
    throw new Error('Failed to qualify lead');
  }

  return response as QualificationResponse;
};
